import Vue from 'vue'
import Router from 'vue-router'
import Main from './views/home/Main'
import ArticleDetail from './views/home/ArticleDetail'
import Articles from './views/home/Articles'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/ArticleDetail',
      name: 'ArticleDetail',
      component: ArticleDetail
    },
    {
      path: '/Articles',
      name: 'Articles',
      component: Articles
    }
  ]
})
